export default __webpack_public_path__ + "static/media/ditLoginLeftImage1.5.09723a42.png";